export const NavButton = (props: { onPress(): void; }) => {
  return (
    <div className="nav-button" onClick={props.onPress}>
      <svg height="48" width="48"><path d="M6 36v-3h36v3Zm0-10.5v-3h36v3ZM6 15v-3h36v3Z"/></svg>
    </div>
  );
};